import {
  HomeIcon,
  BookOpenIcon,
  BuildingStorefrontIcon,
  FolderOpenIcon,
  DocumentTextIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  TableCellsIcon,
  MicrophoneIcon,
  UserPlusIcon,
  Squares2X2Icon,
  ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Home",
    href: "/hub",
    icon: HomeIcon,
    current: false,
    internalName: "home",
    permissions: ["resources"],
  },
  {
    name: "Resource Library",
    href: "/hub/resources",
    icon: BookOpenIcon,
    current: false,
    internalName: "resource_library",
    permissions: ["resources"],
  },
  {
    name: "News",
    href: "/hub/news",
    icon: DocumentTextIcon,
    current: false,
    internalName: "news",
    permissions: ["resources"],
  },
  {
    name: "Podcasts",
    href: "/hub/podcasts",
    icon: MicrophoneIcon,
    current: false,
    internalName: "podcasts",
    permissions: ["resources"],
  },
  {
    name: "Financial Reports",
    href: "/hub/financial-reports",
    icon: FolderOpenIcon,
    current: false,
    internalName: "financial_reports",
    permissions: [
      "financial-reports-monthly-balance",
      "financial-reports-p-and-l-report-builder",
      "financial-reports-transaction-list",
    ],
    children: [
      {
        name: "Monthly Balance Sheet",
        href: "/hub/financial-reports/monthly-balance-sheet",
        icon: ChartBarIcon,
        current: false,
        internalName: "monthly_balance_sheet",
        permissions: ["financial-reports-monthly-balance"],
      },
      {
        name: "Profit and Loss",
        href: "/hub/financial-reports/profit-and-loss-builder",
        icon: CurrencyDollarIcon,
        current: false,
        internalName: "profit_and_loss_builder",
        permissions: ["financial-reports-p-and-l-report-builder"],
      },
      {
        name: "Transaction List",
        href: "/hub/financial-reports/transaction-list",
        icon: TableCellsIcon,
        current: false,
        internalName: "transaction_list",
        permissions: ["financial-reports-transaction-list"],
      },
    ],
  },
  {
    name: "Lead Generation",
    href: "/hub/lead-generation",
    icon: UserPlusIcon,
    current: false,
    internalName: "lead_generation",
    // Not yet GA: visible to everyone in dev/staging, and to CertainPath
    // staff in production. Gates on the employee's own company so coaches
    // keep it while switched into client companies.
    isCertainPathEmployeeOnly:
      import.meta.env.VITE_ENVIRONMENT === "production",
  },
  {
    name: "FieldCoach",
    href: "/hub/fieldcoach",
    icon: ChatBubbleLeftRightIcon,
    current: false,
    internalName: "fieldcoach",
    // Not yet GA — see Lead Generation above.
    isCertainPathEmployeeOnly:
      import.meta.env.VITE_ENVIRONMENT === "production",
  },
  {
    name: "Growth Stages",
    href: "/hub/growth-stages",
    icon: Squares2X2Icon,
    current: false,
    internalName: "growth_stages",
    // Not yet GA — see Lead Generation above.
    isCertainPathEmployeeOnly:
      import.meta.env.VITE_ENVIRONMENT === "production",
  },
  {
    name: "Product Catalog",
    href: "/catalog",
    icon: BuildingStorefrontIcon,
    current: false,
    internalName: "product_catalog",
    // Not yet GA — see Lead Generation above.
    isCertainPathEmployeeOnly:
      import.meta.env.VITE_ENVIRONMENT === "production",
  },
];

const hubConfig = {
  sectionName: "hub",
  defaultRoute: "/hub",
  navigation,
};

export default hubConfig;
